import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';

import { ToastService } from 'src/app/Shared/services/toast/toast.service';

import { LandingService } from '../../_services/landing.service';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NumbersOnlyDirective } from 'src/app/Shared/directives/numbersOnly/numbers-only.directive';
import { validateFullName } from 'src/app/_utlis/app-validators';
import { MatError } from '@angular/material/form-field';
import { TranslatePipe, TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-contact-us-form',
        standalone: true,
imports: [ReactiveFormsModule, CommonModule, NumbersOnlyDirective, MatError,
        TranslatePipe
    ],
    templateUrl: './contact-us-form.component.html',
    styleUrl: './contact-us-form.component.scss'
})
export class ContactUsFormComponent {
  isBrowser: any;
  currentLang: any;
  loggedIn = false;

  contactForm!: FormGroup;
  isSubmitting = false;
  constructor(
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: any,
    private homeService: LandingService,
    private toastService: ToastService,
    private translate: TranslateService,
    private fb: FormBuilder,
    private el: ElementRef
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required, , validateFullName]],
      phone: ['', [Validators.pattern(/^\+?[0-9\s-]{10,15}$/)]],
      email: ['', [Validators.email]],
      message: ['', [Validators.required, Validators.minLength(10)]],
    });
  }

  onSubmit(): void {
    if (this.contactForm.invalid) {
      this.scrollToFirstError();
      this.markFormGroupTouched(this.contactForm);
      return;
    }

    this.isSubmitting = true;

    const formData = {
      name: this.contactForm.get('name')?.value,
      phone: this.contactForm.get('phone')?.value,
      email: this.contactForm.get('email')?.value,
      message: this.contactForm.get('message')?.value,
    };

    this.homeService.contactUs(formData).subscribe({
      next: (response) => {
        this.isSubmitting = false;
        this.contactForm.reset();
        this.toastService.showSuccess(response?.message);
      },
      error: (error) => {
        this.isSubmitting = false;
        this.scrollToFirstError();
        this.toastService.showError(
          'Failed to send message. Please try again.'
        );
      },
    });
  }
  scrollToFirstError(): void {
    setTimeout(() => {
      const firstErrorElement: HTMLElement | null =
        this.el.nativeElement.querySelector(
          '.is-invalid.input-field , .is-invalid input, .is-invalid textarea, .is-invalid select, .is-invalid mat-select, .is-invalid .map .my-search-box , .is-invalid mat-form-field,.is-invalid ng-select'
        );

      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        firstErrorElement.focus();
      }
    }, 100);
  }

  markFormGroupTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      control?.markAsTouched();
      control?.markAsDirty();
    });
  }

  // Helper methods for template
  hasError(controlName: string, errorName: string): boolean {
    const control = this.contactForm.get(controlName);
    return !!(control?.touched && control?.hasError(errorName));
  }
}
